var map = {
	"./Disabled.svg": 37388,
	"./HasWarnings.svg": 16752,
	"./Healthy.svg": 23391,
	"./Unavailable.svg": 66286,
	"./Unhealthy.svg": 1796,
	"./Unknown.svg": 60311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39081;